export { DocumentDuplicate as default } from './DocumentDuplicate';
